import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal, ModalBody, ModalHeader, Table } from 'reactstrap'
import { getOrganizationList } from '../../redux/actions/indexActions'
import { AiOutlineEdit, AiOutlineDelete, AiOutlineEye } from "react-icons/ai"
import { Link } from 'react-router-dom'
import axios from 'axios'
import { toast } from 'react-toastify'
import { Button } from 'reactstrap'
import { MdAdd } from "react-icons/md"
import { Spinner } from "reactstrap"
import { Input } from "reactstrap"
import Pagination from '../../Components/Paginate'
const OrganizationList = () => {
    const dispatch = useDispatch()
    const { AuthReducer: { auth }, indexReducer: { organizationLists, loading, organizationCount }, PermissionReducer: { allowedPermissions } } = useSelector(state => state)
    const [page, setPage] = useState(0);
    const [sort, setSort] = useState("desc");
    const [paginate, setPaginate] = useState(10);
    const [search, setSearch] = useState("");
    const [details, setDetails] = useState({});
    const [isOpen, setIsOpen] = useState(false);
    const indexOfLastItem = (page + 1) * paginate;
    const indexOfFirstItem = indexOfLastItem - paginate;

    const toggle = () => setIsOpen((prev) => !prev);

    useEffect(() => {
        dispatch(getOrganizationList(auth?.token, paginate, page, search, sort))
    }, [auth, paginate, page, search, sort])


    const handleDel = (id) => {
        if (window.confirm("Are You Sure You Want To Delete This Organization")) {
            axios.delete(`/api/admin/v1/organization-delete/${id}`, {
                headers: {
                    Authorization: `Bearer ${auth?.token}`
                }
            })
                .then((res) => {
                    toast.success(res.data.message)
                    dispatch(getOrganizationList(auth?.token))
                }
                ).catch((err) => toast.error("Somthing Went Wrong"))
        }
    }

    return (
        <div>
            <div className="row my-3">
                <div className="col-md-12">
                    <div className="d-flex align-items-center justify-content-between">
                        <h5 className='mb-0 text-white'>Organizations</h5>
                        {allowedPermissions?.some?.((item) => item?.permission?.moduleType === "ORGANIZATIONLIST" && item?.permission?.permission === "create") && (
                            <Link to="/add-organization" >
                                <Button className='bg-white text-black' style={{ color: "primary" }} size='sm' >
                                    <span className='me-2' >
                                        <MdAdd size={22} />
                                    </span>
                                    Add Organization
                                </Button>
                            </Link>
                        )}
                    </div>
                </div>
            </div>
            <div className='bg-white px-3 py-4 rounded-2  my-4' style={{ boxShadow: "4px 4px 18px rgba(0,0,0,0.15)" }}  >
                <div className="row">
                    <div className="col-md-3 mb-2 ">
                        <Input size={"sm"} value={search} placeholder='Search By Name' onChange={(({ target: { value } }) => setSearch(value))} />
                    </div>
                    <div className="col-md-2 offset-md-7">
                        <Input type="select" size={"sm"} value={sort} onChange={(({ target }) => setSort(target.value))} >
                            <option value="asc">Ascending</option>
                            <option value="desc">Descending</option>
                        </Input>
                    </div>

                    <div className="col-md-12">
                        <Table
                            hover
                            responsive
                        >
                            <thead>
                                <tr>
                                    <th>
                                        SL. No.
                                    </th>
                                    <th>
                                        Name
                                    </th>
                                    <th>
                                        Email
                                    </th>
                                    <th>
                                        Mobile
                                    </th>
                                    <th>
                                        Thumbnail
                                    </th>
                                    <th>
                                        View Password
                                    </th>
                                    {allowedPermissions?.some?.((item) => item?.permission?.moduleType === "ORGANIZATIONLIST" && (item?.permission?.permission === "edit" || item?.permission?.permission === "delete")) && (
                                        <th>
                                            Action
                                        </th>
                                    )}
                                </tr>
                            </thead>
                            {
                                loading ? <Spinner /> : <tbody>
                                    {organizationLists.length === 0 ? (
                                        <tr>
                                            <td colSpan="6">No data found</td>
                                        </tr>
                                    ) : (<>
                                        {organizationLists?.map?.((item, index) => {
                                            return (<tr key={item.id}>
                                                <th scope="row">
                                                    {(index + 1) + (page * paginate)}
                                                </th>
                                                <td>
                                                    {item?.name}
                                                </td>
                                                <td>
                                                    {item?.email}
                                                </td>
                                                <td>
                                                    {item?.mobile}
                                                </td>
                                                <td>
                                                    <img
                                                        src={process.env.REACT_APP_IMAGE_URL + `/${item?.thumbnail}`}
                                                        height={45}
                                                        width={45}
                                                    />
                                                </td>
                                                <td>
                                                    <span
                                                        role="button"
                                                        title="View Password"
                                                        onClick={() => {
                                                            setDetails(item.plainPassword);
                                                            toggle();
                                                        }}
                                                    >
                                                        <AiOutlineEye size={22} style={{ margin: 10 }} />
                                                    </span>
                                                </td>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        {
                                                            allowedPermissions?.some?.((item) => item?.permission?.moduleType === "ORGANIZATIONLIST" && item?.permission?.permission === "edit") &&
                                                            <Link to={`/edit-organization/${item?.id}`}>
                                                                <AiOutlineEdit size={22} className='text-warning me-3' />
                                                            </Link>
                                                        }
                                                        {
                                                            allowedPermissions?.some?.((item) => item?.permission?.moduleType === "ORGANIZATIONLIST" && item?.permission?.permission === "delete") &&
                                                            <AiOutlineDelete size={22} className='text-danger' onClick={() => handleDel(item.id)} />
                                                        }
                                                    </div>
                                                </td>
                                            </tr>
                                            )
                                        })}</>
                                    )}
                                </tbody>
                            }
                        </Table>
                    </div>
                </div>
                <Modal isOpen={isOpen} toggle={toggle} size="sm">
                    <ModalHeader toggle={toggle}>Organization Detail</ModalHeader>
                    <ModalBody>
                        <div className="col-md-12">
                            <div className="mt-1">
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <td>Password:</td>
                                            <td>{details}</td>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
                <div className="row align-items-center">
                    <div className="col-md-6 d-flex">
                        <div className="col-md-2">
                            <Input
                                type="select"
                                id="paginate"
                                onChange={e =>
                                    setPaginate(
                                        e.target.value
                                    )
                                }
                                value={paginate}
                                className="paging custom-select custom-select-page m-0"
                            >
                                <option value="10">
                                    10
                                </option>
                                <option value="20">
                                    20
                                </option>
                                <option value="50">
                                    50
                                </option>
                                <option value="100">
                                    100
                                </option>
                                <option value="200">
                                    200
                                </option>
                                <option value="500">
                                    500
                                </option>
                            </Input>
                        </div>
                        <div className='col-md-10 text-black d-flex align-items-center ps-3'>
                            {organizationCount > 0 ? (
                                <>
                                    Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, organizationCount)} of {organizationCount} entries
                                </>
                            ) : (
                                <>
                                    Showing 0 to 0 of 0 entries
                                </>
                            )}
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='d-flex justify-content-end'>
                            <Pagination
                                pageCount={(organizationCount) / paginate}
                                onChange={(e) => setPage(e.selected)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OrganizationList